const TEAMID = '375626';
// Initialize the TintEcommerceMeasure client with the team ID
const client = new Tint.TintEcommerceMeasure(TEAMID);
// Record page load; should be called on every page
client.init();